import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, watch, withDefaults } from 'vue';
interface Props {
  modelValue: boolean;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxPC',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: boolean, disabled: boolean };


const checked: Ref<boolean> = ref(props.modelValue);


watch(
  () => props.modelValue,
  value => {
    checked.value = props.disabled ? true : value;
  },
  { immediate: true }
);

function handleCheckBoxClick() {
  checked.value = !checked.value;
  emit('input', checked.value);
}

function handleValueChange(event: any) {
  checked.value = event.target.checked;
  emit('input', event.target.checked);
}

return { __sfc: true,props, checked, emit, handleCheckBoxClick, handleValueChange }
}

})